import { uniqueId } from 'lodash';
import {
  PackQuantitiesWithMultiplier,
  QuantityBySize,
} from '../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import {
  OrderProductSelectedPack,
  PackQuantityToScreenshot,
} from '../../../../../../../products/details/productDetails.types';
import { SuggestedGridItem } from '../../../../suggestedGrid/suggested-grid.interface';
import {
  CommonGridTypeEnum,
  IOrderProductCommonGrid,
  QuantityByProductSizeId,
} from '../types/commonGrid.types';

const getSuggestedGridQuantities = (
  suggestedGridItems: SuggestedGridItem[],
  allSizeNames: string[],
) => {
  const allGridQuantities = allSizeNames.map((sizeName) => {
    const currentSuggestedGridItem = suggestedGridItems.find((item) => item.size.name === sizeName);
    if (!currentSuggestedGridItem) {
      return {
        sizeId: uniqueId(),
        sizeName,
        sizeQuantity: 0,
      };
    }

    return {
      sizeName,
      sizeId: currentSuggestedGridItem.size.id,
      sizeQuantity: currentSuggestedGridItem.orderItemQuantity ?? 0,
    };
  });

  return allGridQuantities;
};

export const getCommonGridFromSuggestedGrid = (
  suggestedGrid: SuggestedGridItem[],
  allSizesNames: string[],
): IOrderProductCommonGrid | undefined => {
  if (suggestedGrid.length >= 1) {
    const grid: IOrderProductCommonGrid = {
      gridId: suggestedGrid[0].skuId,
      gridName: 'pedido sugerido',
      gridType: CommonGridTypeEnum.SUGGESTED_GRID,
      gridQuantities: getSuggestedGridQuantities(suggestedGrid, allSizesNames),
    };
    return grid;
  }
};

export const getQuantitiesFromCommonGrid = (
  commonGrid: IOrderProductCommonGrid,
): QuantityByProductSizeId =>
  new Map(commonGrid.gridQuantities.map(({ sizeId, sizeQuantity }) => [sizeId, sizeQuantity]));

export const getQuantitiesFromPacks = (
  packs: PackQuantitiesWithMultiplier[],
): QuantityByProductSizeId => {
  const quantities: QuantityByProductSizeId = new Map();

  for (let packIndex = 0; packIndex < packs.length; packIndex++) {
    const { quantitiesBySize, multiplier } = packs[packIndex];
    const packMultiplier = multiplier ?? 1;

    for (let sizeIndex = 0; sizeIndex < quantitiesBySize.length; sizeIndex++) {
      const { size, quantity } = quantitiesBySize[sizeIndex];
      const currentQuantity = quantities.get(size.id) ?? 0;

      quantities.set(size.id, currentQuantity + quantity * packMultiplier);
    }
  }

  return quantities;
};

const getQuantityBySizeFromScreenshot = (
  quantityScreenshot: PackQuantityToScreenshot,
): QuantityBySize => {
  return {
    size: { id: quantityScreenshot.sizeId, name: '' },
    quantity: quantityScreenshot.quantity,
  };
};

export const getPacksWithQuantitiesFromSelectedPacks = (
  selectedPacks: OrderProductSelectedPack[],
): PackQuantitiesWithMultiplier[] => {
  const packsWithQuantities = selectedPacks.map((pack) => {
    const formatted: PackQuantitiesWithMultiplier = {
      id: pack.packId,
      name: pack.packName,
      multiplier: pack.quantity,
      quantitiesBySize: pack.packQuantitiesScreenshot.map((quantityScreenshot) =>
        getQuantityBySizeFromScreenshot(quantityScreenshot),
      ),
    };
    return formatted;
  });
  return packsWithQuantities;
};
